import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Blank_instance9t9guv2wakl7 as Blank_instance } from './RecyclerViewRenderer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RecyclerViewRendererSet$Companion$single$1$r$1Class;
function RecyclerViewRendererSet$Companion$single$1$r$1() {
  if (RecyclerViewRendererSet$Companion$single$1$r$1Class === VOID) {
    class $ {
      constructor($render) {
        this.odk_1 = $render;
      }
      pdg(viewWriter, data, index) {
        return this.odk_1(viewWriter, data);
      }
    }
    initMetadataForClass($);
    RecyclerViewRendererSet$Companion$single$1$r$1Class = $;
  }
  return RecyclerViewRendererSet$Companion$single$1$r$1Class;
}
var RecyclerViewRendererSet$Companion$single$1Class;
function RecyclerViewRendererSet$Companion$single$1() {
  if (RecyclerViewRendererSet$Companion$single$1Class === VOID) {
    class $ {
      constructor($id, $render) {
        this.qdk_1 = $id;
        var tmp = this;
        tmp.pdk_1 = new (RecyclerViewRendererSet$Companion$single$1$r$1())($render);
      }
      kdg(item) {
        return this.qdk_1(item);
      }
      jdg(item) {
        return this.pdk_1;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [RecyclerViewRendererSet()]);
    RecyclerViewRendererSet$Companion$single$1Class = $;
  }
  return RecyclerViewRendererSet$Companion$single$1Class;
}
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      rdk(item) {
        return Unit_instance;
      }
      kdg(item) {
        this.rdk((item == null ? true : !(item == null)) ? item : THROW_CCE());
        return Unit_instance;
      }
      sdk(item) {
        return Blank_instance;
      }
      jdg(item) {
        return this.sdk((item == null ? true : !(item == null)) ? item : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Empty', VOID, VOID, [RecyclerViewRendererSet()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      add(id, render) {
        return new (RecyclerViewRendererSet$Companion$single$1())(id, render);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var RecyclerViewRendererSetClass;
function RecyclerViewRendererSet() {
  if (RecyclerViewRendererSetClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RecyclerViewRendererSet');
    RecyclerViewRendererSetClass = $;
  }
  return RecyclerViewRendererSetClass;
}
//region block: init
Empty_instance = new (Empty())();
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RecyclerViewRendererSet as RecyclerViewRendererSet341fhovxcnndi,
  Companion_instance as Companion_instance28p2tgglllsme,
  Empty_instance as Empty_instance2shmal1dtwu66,
};
//endregion

//# sourceMappingURL=RecyclerViewRendererSet.mjs.map
